export { Animation } from './Animation';

export { Colors } from './Colors';
export type { ColorName, ColorValue } from './Colors';

export { Shadows } from './Shadows';
export type { ShadowName, ShadowValue } from './Shadows';

export { Typography } from './Typography';
export type { TypographyName } from './Typography';

export { Zindexes } from './Zindexes';
